<template lang="pug">
.ml-oauth-callback
  .ml-oauth-callback__card
    img.ml-oauth-callback__logo(src="../assets/logos/original.png" alt="12 Horas Envíos")
    .ml-oauth-callback__body
      template(v-if="status === 'success'")
        h4.ml-oauth-callback__title.ml-oauth-callback__title--success Mercado Libre conectado correctamente
        p Los envíos Flex cuyo reporte traiga un código alfanumérico se completarán automáticamente con su número de envío.
      template(v-else-if="status === 'not_linked'")
        h4.ml-oauth-callback__title Falta vincular tu cuenta de 12 Horas Envíos
        p Inicia sesión en 12 Horas Envíos, ve a Integraciones y presiona "Conectar con Mercado Libre".
      template(v-else-if="status === 'denied'")
        h4.ml-oauth-callback__title.ml-oauth-callback__title--warning Autorización cancelada
        p No se otorgaron permisos en Mercado Libre. Puedes intentarlo nuevamente desde Integraciones.
      template(v-else)
        h4.ml-oauth-callback__title.ml-oauth-callback__title--error No se pudo conectar Mercado Libre
        p Inténtalo nuevamente o escríbenos a contacto@12horasenvios.com.
      router-link.ml-oauth-callback__link(:to="{ name: 'IntegrationView' }") Volver a integraciones
</template>

<script>
export default {
  name: 'MercadolibreOAuthCallbackView',
  computed: {
    status() {
      return this.$route.query.status
    }
  }
}
</script>

<style scoped>
.ml-oauth-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 16px;
  background: var(--secondary);
}

.ml-oauth-callback__card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 6px #00000029;
  text-align: center;
  padding: 22px 20px 28px;
}

.ml-oauth-callback__logo {
  height: 60px;
}

.ml-oauth-callback__body {
  padding-top: 24px;
}

.ml-oauth-callback__title--success {
  color: #2f855a;
}

.ml-oauth-callback__title--warning {
  color: #b7791f;
}

.ml-oauth-callback__title--error {
  color: #c53030;
}

.ml-oauth-callback__link {
  display: inline-block;
  margin-top: 12px;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  background: var(--primary);
  color: #fff;
  font-weight: 600;
}

.ml-oauth-callback__link:hover {
  color: #fff;
  text-decoration: none;
  filter: brightness(0.95);
}
</style>
